export default __webpack_public_path__ + "static/media/english-to-swedish-screenshot-06.4447fd4e.png";